import BindingContext, { IEntity } from "@odata/BindingContext";
import { IPrEmploymentEntity } from "@odata/GeneratedEntityTypes";
import { IDefinition } from "@pages/PageUtils";
import { getCompanyCurrency } from "@utils/CompanyUtils";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import CurrencyType from "../../../../types/Currency";
import PlugAndPlayForm from "../../../../views/formView/PlugAndPlayForm";
import { getEmploymentInitialDataFormDef } from "./EmploymentInitialData.def";
import { getInitialDataDialogData } from "./EmploymentInitialData.utils";
import EmploymentInitialDataFormView from "./EmploymentInitialDataFormView";

interface IProps extends WithTranslation {
    bindingContext: BindingContext;
    employment: IPrEmploymentEntity;
    isReadOnly: boolean;
    onClose: () => void;
    onConfirm: (confirmedData: IEntity) => void;
}

class EmploymentInitialDataDialog extends React.PureComponent<IProps> {
    getDefinition = (context: IAppContext): IDefinition => {
        return {
            form: getEmploymentInitialDataFormDef(
                this.props.employment,
                CurrencyType.getCurrencyUnit(getCompanyCurrency(context)),
                this.props.isReadOnly
            )
        };
    };

    render(): React.ReactElement {
        return (
            <PlugAndPlayForm bindingContext={this.props.bindingContext}
                             data={getInitialDataDialogData(this.props.employment)}
                             formView={EmploymentInitialDataFormView}
                             formViewProps={{
                                 dialogProps: {
                                     isEditableWindow: true
                                 },
                                 formProps: {
                                     withoutPadding: false,
                                     hideHeader: false,
                                     shouldHideVariant: true,
                                     shouldHideAuditTrail: true
                                 },
                                 onAfterConfirm: this.props.onConfirm,
                                 onClose: this.props.onClose,
                             }}
                             getDef={this.getDefinition}
                             t={this.props.t}/>
        );
    }
}

export default withTranslation(["Employee", "Common", "SalaryComponent"])(EmploymentInitialDataDialog);
